/* 
	该文件专门为组件生成action对象
*/

import { LOGIN } from "../../config/constant"

export const changeRoleLogin = (data) => { return { type: LOGIN, data } }